"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileNavItemType = exports.DesktopNavItemType = exports.ConsumerApp = void 0;
var ConsumerApp;
(function (ConsumerApp) {
    ConsumerApp["Unset"] = "Unset";
    ConsumerApp["Stories"] = "Stories";
    ConsumerApp["Spotlight"] = "Spotlight";
    ConsumerApp["Chat"] = "Chat";
    ConsumerApp["Lens"] = "Lenses";
    ConsumerApp["Map"] = "Map";
})(ConsumerApp = exports.ConsumerApp || (exports.ConsumerApp = {}));
// This is used for filling in `destination` field for WEB_ACTION blizzard event
var DesktopNavItemType;
(function (DesktopNavItemType) {
    DesktopNavItemType["STORIES"] = "DISCOVER_HOME_PAGE";
    DesktopNavItemType["SPOTLIGHT"] = "SPOTLIGHT";
    DesktopNavItemType["CHAT"] = "CHAT";
    DesktopNavItemType["LENS"] = "LENS_HOME_PAGE";
    DesktopNavItemType["MAP"] = "MAP";
    DesktopNavItemType["SNAPCHAT_OVERVIEW"] = "SNAPCHAT_OVERVIEW";
    DesktopNavItemType["ACCOUNTS"] = "ACCOUNTS";
    DesktopNavItemType["SNAPCHAT_SUPPORT"] = "SNAPCHAT_SUPPORT";
    DesktopNavItemType["FOR_BUSINESS"] = "FOR_BUSINESS";
    DesktopNavItemType["ADS_MANAGER"] = "ADS_MANAGER";
    DesktopNavItemType["BUSINESS_SUPPORT"] = "BUSINESS_SUPPORT";
    DesktopNavItemType["LENS_STUDIO"] = "LENS_STUDIO";
    DesktopNavItemType["CREATOR_CAMERA"] = "CREATOR_CAMERA";
    DesktopNavItemType["CREATOR"] = "CREATOR";
    DesktopNavItemType["FOR_DEVELOPERS"] = "FOR_DEVELOPERS";
    DesktopNavItemType["SNAP_KIT"] = "SNAP_KIT";
    DesktopNavItemType["SNAP_MINIS"] = "SNAP_MINIS";
    DesktopNavItemType["SNAP_GAMES"] = "SNAP_GAMES";
    DesktopNavItemType["PLAYCANVAS"] = "PLAYCANVAS";
    DesktopNavItemType["SPECTACLES_OVERVIEW"] = "SPECTACLES_OVERVIEW";
    DesktopNavItemType["SPECTACLES_CREATOR"] = "SPECTACLES_CREATOR";
    DesktopNavItemType["SPECTACLES_SUPPORT"] = "SPECTACLES_SUPPORT";
    DesktopNavItemType["SUB_MENU"] = "SUB_MENU";
    DesktopNavItemType["CREATE_STORY_LINK"] = "CREATE_STORY_LINK";
    DesktopNavItemType["DOWNLOAD"] = "DOWNLOAD";
    DesktopNavItemType["STORE"] = "STORE";
    DesktopNavItemType["SCAN"] = "SCAN";
    DesktopNavItemType["PRIVACY_AND_SAFETY"] = "PRIVACY_AND_SAFETY";
    DesktopNavItemType["YOUR_PRIVACY_CHOICES"] = "YOUR_PRIVACY_CHOICES";
    DesktopNavItemType["SNAPCHAT_PLUS"] = "SNAPCHAT_PLUS";
})(DesktopNavItemType = exports.DesktopNavItemType || (exports.DesktopNavItemType = {}));
// This is used for filling in `destination` field for WEB_ACTION blizzard event
var MobileNavItemType;
(function (MobileNavItemType) {
    MobileNavItemType["UNSET"] = "UNSET";
    MobileNavItemType["STORIES"] = "DISCOVER_HOME_PAGE";
    MobileNavItemType["SPOTLIGHT"] = "SPOTLIGHT";
    MobileNavItemType["CHAT"] = "CHAT";
    MobileNavItemType["LENS"] = "LENS_HOME_PAGE";
    MobileNavItemType["MAP"] = "MAP";
    MobileNavItemType["ACCOUNTS"] = "ACCOUNTS";
    MobileNavItemType["SNAPCHAT_SUPPORT"] = "SNAPCHAT_SUPPORT";
    MobileNavItemType["ADS"] = "ADS";
    MobileNavItemType["DOWNLOAD"] = "DOWNLOAD";
    MobileNavItemType["FOR_BUSINESS"] = "FOR_BUSINESS";
    MobileNavItemType["ADS_MANAGER"] = "ADS_MANAGER";
    MobileNavItemType["SNAP_PUBLISHER"] = "SNAP_PUBLISHER";
    MobileNavItemType["BUSINESS_SUPPORT"] = "BUSINESS_SUPPORT";
    MobileNavItemType["PUBLIC_PROFILES_FOR_BUSINESS"] = "PUBLIC_PROFILES_FOR_BUSINESS";
    MobileNavItemType["SNAP_AR"] = "SNAP_AR";
    MobileNavItemType["LENS_STUDIO"] = "LENS_STUDIO";
    MobileNavItemType["LENS_WEB_BUILDER"] = "LENS_WEB_BUILDER";
    MobileNavItemType["CAMERA_KIT"] = "CAMERA_KIT";
    MobileNavItemType["SNAP_CAMERA"] = "SNAP_CAMERA";
    MobileNavItemType["SHOP_PIXY"] = "SHOP_PIXY";
    MobileNavItemType["PIXY_SUPPORT"] = "PIXY_SUPPORT";
    MobileNavItemType["SPECTACLES"] = "SPECTACLES";
    MobileNavItemType["SPECTACLES_CREATOR"] = "SPECTACLES_CREATOR";
    MobileNavItemType["SPECTACLES_SUPPORT"] = "SPECTACLES_SUPPORT";
    MobileNavItemType["FOR_DEVELOPERS"] = "FOR_DEVELOPERS";
    MobileNavItemType["SNAP_KIT"] = "SNAP_KIT";
    MobileNavItemType["SNAP_MINIS"] = "SNAP_MINIS";
    MobileNavItemType["SNAP_GAMES"] = "SNAP_GAMES";
    MobileNavItemType["PLAYCANVAS"] = "PLAYCANVAS";
    MobileNavItemType["MARKETING_API"] = "MARKETING_API";
    MobileNavItemType["SNAP_INC"] = "SNAP_INC";
    MobileNavItemType["INVESTORS"] = "INVESTORS";
    MobileNavItemType["CAREERS"] = "CAREERS";
    MobileNavItemType["NEWS"] = "NEWS";
    MobileNavItemType["SAFETY_IMPACT"] = "SAFETY_IMPACT";
    MobileNavItemType["CITIZEN_SNAP"] = "CITIZEN_SNAP";
    MobileNavItemType["BITMOJI"] = "BITMOJI";
    MobileNavItemType["ZENLY"] = "ZENLY";
    MobileNavItemType["CREATOR_HUB"] = "CREATOR_HUB";
    MobileNavItemType["POST_TO_SPOTLIGHT"] = "POST_TO_SPOTLIGHT";
    MobileNavItemType["SUB_MENU"] = "SUB_MENU";
    MobileNavItemType["PRIVACY_POLICY"] = "PRIVACY_POLICY";
    MobileNavItemType["TERMS_OF_SERVICE"] = "TERMS_OF_SERVICE";
    MobileNavItemType["COOKIE_POLICY"] = "COOKIE_POLICY";
    MobileNavItemType["PRIVACY_AND_SAFETY"] = "PRIVACY_AND_SAFETY";
    MobileNavItemType["YOUR_PRIVACY_CHOICES"] = "YOUR_PRIVACY_CHOICES";
    MobileNavItemType["SNAPCHAT_PLUS"] = "SNAPCHAT_PLUS";
})(MobileNavItemType = exports.MobileNavItemType || (exports.MobileNavItemType = {}));
//# sourceMappingURL=datatypes.js.map